var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGotoProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_108_1",
    "data-name": "Component 108 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.752,
    height: 21,
    viewBox: "0 0 23.752 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M11.076,17.158H8.865A6.363,6.363,0,0,0,2.51,23.513v1.658A.828.828,0,0,0,3.339,26H16.6a.828.828,0,0,0,.829-.829V23.513A6.363,6.363,0,0,0,11.076,17.158Zm4.7,7.184H4.168v-.829a4.7,4.7,0,0,1,4.7-4.7h2.211a4.7,4.7,0,0,1,4.7,4.7Zm-5.8-7.737a5.8,5.8,0,1,0-5.8-5.8A5.809,5.809,0,0,0,9.971,16.605Zm0-9.947A4.145,4.145,0,1,1,5.826,10.8,4.146,4.146,0,0,1,9.971,6.658Zm16.242,8.826a.033.033,0,0,0-.006-.022v-.006a.809.809,0,0,0-.16-.243.121.121,0,0,1-.017-.028l-2.211-2.211a.828.828,0,1,0-1.172,1.172l.79.8H18.254a.829.829,0,0,0,0,1.658h5.184l-.8.8a.824.824,0,0,0,0,1.172.827.827,0,0,0,1.172,0l2.211-2.211a.9.9,0,0,0,.166-.243.486.486,0,0,0,.028-.083.837.837,0,0,0,.039-.2c0-.028.006-.055.006-.083A.729.729,0,0,0,26.212,15.483Z",
    transform: "translate(-2.51 -5)",
    fill: "#999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoProfile);
export default __webpack_public_path__ + "static/media/goto-profile.9ffe0462fde4e3d512d26590d2b6e567.svg";
export { ForwardRef as ReactComponent };